import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { SessionManager } from 'src/app/managers/session/session.manager';

@Injectable({
  providedIn: 'root'
})
export class LoginHandler
{
    constructor(
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
      private _session  : SessionManager
    ) { }

    async login(username: string, psw: string, orgId: number, orgHubId: number , forced: number)
    {      
        // Check if is Valid
        if (!this._utils.checker().isValidText(username)) 
        {
          this._notifier.show(
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_USERNAME 
          )
          return undefined
        } 

        if(!this._utils.checker().hasMinLength(username, 3)){
          this._notifier.show( 
            Notifier.WARNING                        , 
            NotifierMessage.INVALID_USERNAME_LENGTH , 
            {char_number: 3} 
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(psw)) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if(!this._utils.checker().hasMinLength(psw, 3)){
          this._notifier.show( 
            Notifier.WARNING                        , 
            NotifierMessage.INVALID_PASSWORD_LENGTH , 
            {char_number: 3}
          )
          return undefined
        }

        try
        {
          let result = await this._request.login().login( username, psw , orgId, orgHubId, forced ).toPromise()

          if(!User.isKind( result ))
            return this._error.handleCQWebapp( result , { username: username, password: psw } )  

          return result as User
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async logout(token: string)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show( 
            Notifier.WARNING                  , 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        try
        {
          await this._request.login().logout( token ).toPromise()
          return true 
        }catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async passwordChange(token: string, oldPassword: string, newPassword: string, repeatPassword: string)
    {      
        if (!this._utils.checker().isValidText(token)) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                 , 
            NotifierMessage.TOKEN_HAS_EXPIRED
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(oldPassword)) 
        {
          this._notifier.show
          ( 
            Notifier.ERROR                  , 
            NotifierMessage.NOT_SET_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(newPassword)) 
        {
          this._notifier.show
          ( 
            Notifier.ERROR                  , 
            NotifierMessage.NOT_SET_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidText(repeatPassword)) 
        {
          this._notifier.show
          ( 
            Notifier.ERROR                  , 
            NotifierMessage.NOT_SET_PASSWORD,
          )
          return undefined
        }

        if(!this._utils.checker().isEquals(newPassword, repeatPassword))
        {
          this._notifier.show( 
            Notifier.ERROR                   , 
            NotifierMessage.NOT_SAME_PASSWORD,
          )
          return undefined
        }

        try
        {
          let response = await this._request.login().changePassword( token, oldPassword, newPassword ).toPromise()
          
          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )
            return response
          }
        }
        catch(error)
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

